// src/components/shared/RightSidebar.js
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const RightSidebar = ({ isOpen, onClose, children, title = '', wide = false }) => {
    const { t } = useTranslation();
    const overlayRef = useRef();

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (overlayRef.current && e.target === overlayRef.current) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    if (!isOpen) return null;

    return (
        <div className="sidebar-overlay" ref={overlayRef}>
            <div className={`right-sidebar ${wide ? 'wide' : ''}`}>
                <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">{title}</h5>
                    {/* Pulsante X per chiusura manuale */}
                    <button
                        onClick={onClose}
                        aria-label={t('common.close')}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: '1.2rem',
                            lineHeight: 1,
                            color: '#6b7280',
                            padding: '0 4px',
                        }}
                    >
                        ×
                    </button>
                </div>
                <div className="p-3">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default RightSidebar;
